export function isLocalDev() {
  if (process.env.NODE_ENV !== 'development') return false;
  if (typeof window === 'undefined') return false;
  return /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);
}
